<template>
  <div class="container-fluid admin-page">
    <div class="title-area">
      <h2>動画管理</h2>
    </div>
    <div class="search-area">
      <form class="search-form" v-on:submit.prevent>
        <div class="form-group">
          <label class="form-control-label">期間</label>
          <div>
            <MyCalendar
              class="date-from"
              :date-value="searchState.search.dtFrom"
              @date-input="searchState.search.dtFrom = $event"
            />
            <span class="ib waveline ta-center ml4 mr4">〜</span>
            <MyCalendar
              class="date-to"
              :date-value="searchState.search.dtTo"
              @date-input="searchState.search.dtTo = $event"
            />
          </div>
        </div>
        <div class="form-group">
          <label class="form-control-label device-id-or-car-name">車載器ID・車両番号</label>
          <input type="text" class="form-control" v-model="searchState.search.device_id_or_car_name">
        </div>
        <div class="form-group search-btn ta-center">
          <button type="submit" class="btn btn-primary" @click="doSearch" :disabled="!isValidSearchParams">
            検索
          </button>
        </div>
      </form>
      <div class="text-warning movie-group-warn-text ml10 mt8">
        ※エンジンONからOFFまでを一連の動画とし、一行にまとめて表示しています。個別に編集をする場合は地図画面から行ってください。
      </div>
      <div class="text-warning movie-group-warn-text ml10 mt8" v-if="searchState.hasMaxSearchResults">
        ※件数が{{maxSearchResultLimit}}件を超えているので最初の{{maxSearchResultLimit}}件を表示しています
      </div>
    </div>
    <div class="collection-destroy" v-if="selectedNum > 0">
      検索結果{{selectedNum}}件が選択されています。
      <button class="btn btn-info btn-sm" @click="bulkEditMovieTag()">
        <i class="fas fa-tag mr4"></i>一括タグ編集
      </button>
      <button class="btn btn-danger btn-sm ml12" @click="collectionDestroy()">
        <i class="fas fa-trash-alt mr4"></i>一括削除
      </button>
    </div>
    <div class="main-area">
      <Pagination
        :current-page="searchState.pager.currentPage"
        :total-items="searchState.filteredMovieGroups.length"
        :items-per-page="searchState.pager.itemsPerPage"
        @page-click="onPageClick"
      />
      <table class="table admin-table" v-if="searchState.filteredMovieGroups.length > 0">
        <thead>
          <tr class="table-secondary header-row">
            <th class="checkbox">
              <input type="checkbox" v-model="destroyState.allSelected" @change="allSelectBtn" />
            </th>
            <th>開始時刻</th>
            <th>終了時刻</th>
            <th>車載器ID</th>
            <th>車両番号</th>
            <th>動画タグ</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="e in paginatedMovieGroups"
            :key="e.id"
            class="data-row"
            :class="{ checked: e.checked }"
          >
            <td class="vm head-edit">
              <input type="checkbox" v-model="e.checked"/>
            </td>
            <td class="vm ws-nowrap">{{ dtFormat(e.startTs) }}</td>
            <td class="vm ws-nowrap">{{ dtFormat(e.endTs) }}</td>
            <td class="vm ws-nowrap">{{ e.deviceId }}</td>
            <td class="vm ws-nowrap">{{ e.carName }}</td>
            <td class="vm">
              <span
                v-for="(tag, i) in movieTagsOfMovieGroup(e)"
                :key="i"
                class="tag-badge mr4 mb4 ws-nowrap"
                :class="'tag-badge-' + tag.tagType1"
              >
                {{ tag.tagName }}
              </span>
            </td>
            <td class="vm ws-nowrap">
              <button
                type="button"
                class="btn btn-sm btn-info"
                @click="editMovieTag(e)"
              >
                <i class="fas fa-tag"></i>
                タグ編集
              </button>

              <button class="delete-btn btn btn-danger btn-sm" @click="tryDestroy(e)">
                <i class="fas fa-trash-alt mr4"></i>削除
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <Pagination
        :current-page="searchState.pager.currentPage"
        :total-items="searchState.filteredMovieGroups.length"
        :items-per-page="searchState.pager.itemsPerPage"
        @page-click="onPageClick"
      />
    </div>
    <Modal
      v-if="destroyState.showCollectionDestroyModal"
      :title="collectionDestroyModalTitle"
      :show-bottom-dismiss-button="true"
      @close="collectionDestroySave"
      @dismiss="destroyState.showCollectionDestroyModal = false"
    >
      <template v-slot:body>
        <div>
          <p class="p2 font-mtx-desc" v-html="collectionDestroyModalMsg"></p>
        </div>
      </template>
    </Modal>
    <Modal
      v-if="destroyState.showDestroyModal"
      :title="destroyModalTitle"
      :show-bottom-dismiss-button="true"
      @close="doDestroy"
      @dismiss="destroyState.showDestroyModal = false"
    >
      <template v-slot:body>
        <div>
          <p class="p1">開始時刻<span class="colon"></span>{{ dtFormat(destroyState.editting.startTs) }}</p>
          <p class="p1">終了時刻<span class="colon"></span>{{ dtFormat(destroyState.editting.endTs) }}</p>
          <p class="p1">車載器ID<span class="colon"></span>{{ destroyState.editting.deviceId }}</p>
          <p class="p1">車両番号<span class="colon"></span>{{ destroyState.editting.carName }}</p>
          <p class="p2 font-mtx-desc" v-html="destroyModalMsg"></p>
        </div>
      </template>
    </Modal>

    <Modal
      v-if="searchState.showSearchErrorModal"
      title="検索エラー"
      :show-bottom-dismiss-button="false"
      @close="searchState.showSearchErrorModal = false"
    >
      <template v-slot:body>
        <div>
          <p class="p2 font-mtx-desc" v-html="searchErrorModalMsg"></p>
        </div>
      </template>
    </Modal>

    <Modal
      v-if="destroyState.showErrorModal"
      :title="errorModalTitle"
      :show-bottom-dismiss-button="false"
      @close="destroyState.showErrorModal = false"
    >
      <template v-slot:body>
        <div>
          <p class="p2 font-mtx-desc" v-html="errorModalMsg"></p>
        </div>
      </template>
    </Modal>
    <TagModal
      v-if="tagEditState.show"
      title="動画タグの編集"
      v-model="tagEditState.tags"
      @close="updateMovieTags"
      @dismiss="tagEditState.show = false"
    />
  </div>
</template>

<script setup lang="ts">
import movieGroupApi from 'src/apis/movieGroup';
import {
  computed,
  onMounted,
  reactive,
} from 'vue';
import { useFullScreenSpinner } from 'src/composables/useFullScreenSpinner';
import type { AdminMovieGroup, AdminMovieTag } from 'src/models/movieGroup';
import {
  getAggregatedMovieTagsFromMovieLists,
  getAggregatedMovieTagsFromMovieList,
  type MovieTagMap,
  type ResultTag,
} from 'src/lib/tagModalHelper';
import type { PageItem } from 'src/models';
import { dtFormat } from 'src/lib/dateHelper';
import { paginateItems } from 'src/lib/utils';

interface SearchParams {
  dtFrom: Date;
  dtTo: Date;
  device_id_or_car_name: string | null;
}
type FilteredMovieGroup = AdminMovieGroup & {
  checked: boolean;
};
interface MovieTagModal {
  show: boolean;
  movieGroups: AdminMovieGroup[];
  tags: MovieTagMap[];
}
type AdminMovieGroupEdit = Omit<AdminMovieGroup, 'id'> & {
  id: number | null;
};

interface Pagination {
  currentPage: number;
  itemsPerPage: number;
}

interface MovieGroupSearchState {
  search: SearchParams;
  filteredMovieGroups: FilteredMovieGroup[];
  hasMaxSearchResults: boolean;
  showSearchErrorModal: boolean;
  pager: Pagination;
}

interface MovieGroupDestroyState {
  showDestroyModal: boolean;
  showCollectionDestroyModal: boolean;
  showErrorModal: boolean;
  editting: Partial<AdminMovieGroupEdit>;
  allSelected: boolean;
}

const now = new Date();
const initSearchState = (): SearchParams => {
  return {
    // 1週間前から今日
    dtFrom: new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7),
    dtTo: new Date(now.getFullYear(), now.getMonth(), now.getDate()),
    device_id_or_car_name: null,
  };
};
const initEdittingState = (): Partial<AdminMovieGroupEdit> => {
  return {
    id: null,
  };
};
const initEditMovieTagModalState = (): MovieTagModal => {
  return {
    show: false,
    movieGroups: [],
    tags: [],
  };
};
const initPagerState = (): Pagination => {
  return {
    currentPage: 1,
    itemsPerPage: 50,
  };
};
const searchState = reactive<MovieGroupSearchState>({
  search: initSearchState(),
  filteredMovieGroups: [],
  hasMaxSearchResults: false,
  showSearchErrorModal: false,
  pager: initPagerState(),
});
const destroyState = reactive<MovieGroupDestroyState>({
  showDestroyModal: false,
  showCollectionDestroyModal: false,
  showErrorModal: false,
  editting: initEdittingState(),
  allSelected: false,
});
const tagEditState = reactive<MovieTagModal>(initEditMovieTagModalState());

const selectedNum = computed<number>(() => {
  return searchState.filteredMovieGroups.filter((g) => g.checked).length;
});
const paginatedMovieGroups = computed<FilteredMovieGroup[]>(() => {
  return paginateItems(searchState.filteredMovieGroups, searchState.pager);
});
// テンプレートからstateのプロパティに直接アクセスできるよう展開する
const collectionDestroyModalMsg = computed<string>(() => {
  return selectedNum.value.toString() + '件を一括削除してもよろしいですか？';
});
const isValidSearchParams = computed<boolean>(() => {
  const params = searchState.search;
  return params.dtFrom instanceof Date && params.dtTo instanceof Date;
});
const longerThanPeriodLimit = computed<boolean>(() => {
  return searchState.search.dtTo.getTime() - searchState.search.dtFrom.getTime() > 31 * 24 * 60 * 60 * 1000;
});
const maxSearchResultLimit = 1000;
const doSearch = () => {
  if (!isValidSearchParams.value) return;

  if (longerThanPeriodLimit.value) {
    searchState.showSearchErrorModal = true;
    return;
  }
  resetSearchResults();

  const params = searchState.search;
  const reqParams = {
    from_ts: params.dtFrom,
    to_ts: new Date(params.dtTo.valueOf() + 86400 * 1000),
  };

  movieGroupApi.adminIndex(reqParams)
    .then((movieGroupsOrig) => {
      if (!movieGroupsOrig || movieGroupsOrig.length === 0) return;

      if (movieGroupsOrig.length === maxSearchResultLimit) {
        searchState.hasMaxSearchResults = true;
      }
      filterSearch(movieGroupsOrig);
    });
};

onMounted(doSearch);

const filterSearch = (movieGroupsOrig: AdminMovieGroup[]) => {
  searchState.filteredMovieGroups = movieGroupsOrig.filter(movieGroup => {
      if (searchState.search.device_id_or_car_name != null &&
        searchState.search.device_id_or_car_name !== '' &&
        movieGroup.deviceId.toString().indexOf(searchState.search.device_id_or_car_name) < 0 &&
        movieGroup.carName.indexOf(searchState.search.device_id_or_car_name) < 0) {
        return false;
      }
      return true;
    })
    .map(movieGroup => ({ ...movieGroup, checked: false }));
  destroyState.allSelected = false;
};
const resetSearchResults = () => {
  searchState.filteredMovieGroups = [];
  searchState.pager.currentPage = 1;
  searchState.hasMaxSearchResults = false;
};
const onPageClick = (pageItem: PageItem) => {
  searchState.pager.currentPage = pageItem.pageNum;
};
const allSelect = () => {
  for (let i = 0; i < searchState.filteredMovieGroups.length; i++) {
    searchState.filteredMovieGroups[i].checked = true;
  }
};
const allDeselect = () => {
  for (let i = 0; i < searchState.filteredMovieGroups.length; i++) {
    searchState.filteredMovieGroups[i].checked = false;
  }
};
const allSelectBtn = () => {
  if (destroyState.allSelected) {
    allSelect();
  } else {
    allDeselect();
  }
};
const collectionDestroy = () => {
  destroyState.showCollectionDestroyModal = true;
};
const collectionDestroySave = () => {
  const ids = searchState.filteredMovieGroups.filter((g) => {
    return g.checked;
  }).map((g) => {
    return g.id;
  });
  movieGroupApi.adminCollectionDestroy({
    ids: ids,
  }).then(() => {
    destroyState.showCollectionDestroyModal = false;
    doSearch();
  }).catch(() => {
    destroyState.showCollectionDestroyModal = false;
    destroyState.showErrorModal = true;
  });
};
const tryDestroy = (obj: AdminMovieGroup) => {
  destroyState.editting = obj;
  destroyState.showDestroyModal = true;
};
const doDestroy = () => {
  if (destroyState.editting.id == null) return;

  movieGroupApi.adminDestroy(
    destroyState.editting.id,
  ).then(() => {
    destroyState.showDestroyModal = false;
    doSearch();
  }).catch(() => {
    destroyState.showDestroyModal = false;
    destroyState.showErrorModal = true;
  });
};
const movieTagsOfMovieGroup = (mg: AdminMovieGroup): AdminMovieTag[] => {
  const movieTagMap = mg.movies.reduce((acc: { [key:number] : AdminMovieTag }, movie) => {
    movie.tags.forEach(tag => { acc[tag.id] = tag; }); return acc;
  }, {});
  return Object.values(movieTagMap);
};
const bulkEditMovieTag = async() => {
  const mgs = searchState.filteredMovieGroups.filter(g => g.checked);
  tagEditState.movieGroups = mgs;
  tagEditState.tags =
    getAggregatedMovieTagsFromMovieLists(mgs);
  tagEditState.show = true;
};
const editMovieTag = async(obj: AdminMovieGroup) => {
  tagEditState.movieGroups = [obj];
  tagEditState.tags =
    getAggregatedMovieTagsFromMovieList(obj);
  tagEditState.show = true;
};
const fullScreenSpinner = useFullScreenSpinner();
const updateMovieTags = async(resultTags: ResultTag[]) => {
  fullScreenSpinner.notifyShow({ message: '保存しています...', isHtmlMessage: false });
  const movieGroups = tagEditState.movieGroups;
  const promises = movieGroups.map((mg, idx) => {
    const movieInfos = mg.movies.map(m => {
      const tagIds = resultTags.filter(resTag => {
        return !resTag.isPartiallySelected || m.tags.find(e => e.id === resTag.id);
      }).map(e => e.id);
      return { movie_id: m.id, tag_ids: tagIds };
    });
    return movieGroupApi.adminUpdateMovieTags(mg.id, { movie_infos: movieInfos })
      .then((updatedMovieGroup) => {
        movieGroups[idx].movies = updatedMovieGroup.movies;
      });
  });
  try {
    await Promise.all(promises);
  } finally {
    // 保存失敗時もスピナーを出しっぱなしにしない
    fullScreenSpinner.notifyHide();
  }
  tagEditState.show = false;
};

const destroyModalTitle = '削除';
const destroyModalMsg = 'を削除してもよろしいですか？';
const collectionDestroyModalTitle = '一括削除';
const errorModalTitle = 'エラー';
const errorModalMsg = '不明なエラーです。ネットワークの状態をご確認いただき再度お試し下さい。';
const searchErrorModalMsg = '検索期間は31日以内に設定して下さい';
</script>

<style lang="scss"  scoped>
.collection-destroy {
  background-color: #FCF3D1;
  padding: 10px;
  margin-bottom: 10px;
}

.movie-group-warn-text {
  font-size: 0.8rem;
}
</style>
